module.exports = __webpack_public_path__ + "img/graduationcap.16d6e82f.svg";